import type { GetObligationListResponse } from '@risksmart-app/trpc/src/types';
import type { GetObligationListQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetObligationListDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook, type StrictMappedGraphQLSelection } from 'src/utils';

type UseGetObligationListArgs = Record<string, never>;

const mapToGraphQL = (
  data: GetObligationListResponse
): StrictMappedGraphQLSelection<GetObligationListQuery> => ({
  obligation: data.obligation,
  node: data.node,
});

export const useGetObligationList = createQueryHook<
  UseGetObligationListArgs,
  GetObligationListResponse,
  GetObligationListQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.obligation.obligationList.queryOptions(),
  mapTrpcDataToGraphQL: mapToGraphQL,
  graphqlDocument: GetObligationListDocument,
});
